<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.68573 6.11716C7.8593 5.96095 8.1407 5.96095 8.31427 6.11716L11.8698 9.31716C12.0434 9.47337 12.0434 9.72663 11.8698 9.88284C11.6963 10.0391 11.4149 10.0391 11.2413 9.88284L8 6.96569L4.75871 9.88284C4.58515 10.0391 4.30374 10.0391 4.13017 9.88284C3.95661 9.72663 3.95661 9.47337 4.13017 9.31716L7.68573 6.11716Z"
    fill="currenColor" />
</template>
